const umbracoUrls = {
    local: "",
    devTest: "https://unificationdev.azurewebsites.net",
    proxy: "http://localhost:5203/umbraco-site"
}

export const utilityServiceUrls = {
    devTest: "https://wakanda-api.azurewebsites.net",
    local: "http://localhost:5000"
}

export const utilityServiceUrl = utilityServiceUrls.devTest;

export const localEnvironment = {
    useSampleData: false,
    defaultLanguage: "en",
    defaultCulture: "en-za",
    disableAnalytics: false,
    urls: {
        menuConfig: umbracoUrls.local,
        assets: "/content/menu-v2/",
        imagePrefix: ""
    },
    mainLogo: {
        title: "DStv",
        image: "logos/dstv.svg",
        logoHeight: "16px",
        logoMobileHeight: "16px"
    }
};

export const getDevEnvironment = (useSampleData = false, useProxy = false) => {
    const imagePrefix = useSampleData ? "" : umbracoUrls.devTest
    const menuConfig = useProxy ? umbracoUrls.proxy : umbracoUrls.devTest;

    return {
        useSampleData: useSampleData,
        defaultLanguage: "en",
        defaultCulture: "en-za",
        disableAnalytics: false,
        urls: {
            menuConfig: menuConfig,
            assets: "/",
            imagePrefix: imagePrefix
        },
        mainLogo: {
            title: "DStv",
            image: "logos/dstv.svg",
            logoHeight: "24px",
            logoMobileHeight: "24px"
        }
    };
}

export const devEnvironment = getDevEnvironment();
